import React from 'react';

function HeaderBar({
  profileName,
  authUser,
  theme,
  appTitle,
  onToggleTheme,
  onOpenSettings,
  onLogin,
  onLogout,
}) {
  return (
    <header className="App-header">
      <div className="header-content">
        <div className="header-left">
          <button
            type="button"
            className="profile-badge profile-button"
            onClick={onOpenSettings}
            aria-label="Open settings"
          >
            <div className="profile-avatar">
              {profileName.charAt(0) || 'F'}
            </div>
            <div className="profile-details">
              <div className="profile-name">{profileName}</div>
              <div className="profile-email">
                {authUser?.email ? `Account: ${authUser.email}` : 'fitnessjourney.vip'}
              </div>
            </div>
          </button>
          <div className="header-actions">
            <button className="theme-toggle" onClick={onToggleTheme} title="Toggle theme">
              {theme === 'light' ? '🌙' : '☀️'}
            </button>
            {authUser ? (
              <button className="auth-btn" onClick={onLogout}>Sign out</button>
            ) : (
              <button className="auth-btn" onClick={onLogin}>Sign in</button>
            )}
          </div>
        </div>
        <h1>{appTitle}</h1>
      </div>
    </header>
  );
}

export default HeaderBar;